import { sweepCircleVsSegmentCapsule } from "./_wallcast";

export default function drawCircle(g, app, args) {
  const { origin, settings, pxPerMeter, walls, probeRadiusPx } = args;
  const radiusM = Number.isFinite(settings?.radiusM) ? settings.radiusM
                 : Number.isFinite(settings?.radius) ? settings.radius
                 : 3;
  const R = Math.max(0, radiusM) * pxPerMeter;

  const lineW = Number.isFinite(settings?.lineWidthPx) ? settings.lineWidthPx : 2;
  const probeR = Number.isFinite(probeRadiusPx) ? probeRadiusPx
                 : Number.isFinite(settings?.probeRadiusPx) ? settings.probeRadiusPx
                 : Math.max(0, lineW * 0.5);

  const N = Math.max(32, Math.floor(Number(settings?.samples) || 192));
  const dA = (Math.PI * 2) / N;

  // style
  try { g.lineStyle({ width: lineW, color: 0x00ffff, alpha: 1 }); }
  catch { g.lineStyle(lineW, 0x00ffff, 1); }

  const pts = [];
  for (let i = 0; i < N; i++) {
    const a = i * dA;
    const dx = Math.cos(a), dy = Math.sin(a);
    const targetX = origin.x + dx * R;
    const targetY = origin.y + dy * R;

    let bestT = 1, best = null;
    for (const s of walls || []) {
      const h = sweepCircleVsSegmentCapsule(origin.x, origin.y, targetX, targetY, probeR, s.x1, s.y1, s.x2, s.y2);
      if (h && h.time < bestT) { bestT = h.time; best = h; }
    }

    if (!best) {
      pts.push({ x: targetX, y: targetY });
    } else {
      const px = origin.x + (targetX - origin.x) * best.time;
      const py = origin.y + (targetY - origin.y) * best.time;
      const sep = Math.max(0.25, probeR * 0.9);
      pts.push({ x: px - best.nx * sep, y: py - best.ny * sep });
    }
  }

  if (pts.length) {
    g.moveTo(pts[0].x, pts[0].y);
    for (let i = 1; i < pts.length; i++) g.lineTo(pts[i].x, pts[i].y);
    g.lineTo(pts[0].x, pts[0].y);
  }
}
